import { useState } from 'react';
import { TextField, Button, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import auth from '../../../services/AuthService';
import ToastMessage from '@/components/toasts/ToastMessage';

export default function ChangeCodeForm() {
  const [profile, setProfile] = useState({
    code: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfile({ ...profile, [name]: value });
  };

  const changeCode = async () => {
    const { code } = profile;

    if (!code) {
      toast.error('Bitte füllen Sie das Feld aus');
      return;
    }

    if (code.length < 4) {
      toast.error(
        <ToastMessage
          title="Fehler"
          subtitle="Code muss min. 4 Zeichen lang sein!"
        />,
      );
      return;
    }

    try {
      await auth.put('/me/changeCode', JSON.stringify({ code }));
      toast.success(<ToastMessage title="Erfolg" subtitle="Code geändert" />);
    } catch (e) {
      console.log(e.status);
      toast.error(
        <ToastMessage title="Fehler" subtitle={'Code existiert bereits!'} />,
      );
    } finally {
      setProfile({
        code: '',
      });
    }
  };

  return (
    <>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 'bold',
          marginBottom: '20px',
        }}
      >
        Code ändern
      </Typography>
      <TextField
        required
        type="text"
        value={profile.code}
        label="Code"
        variant="outlined"
        fullWidth
        name="code"
        onChange={handleInputChange}
      />
      <Button variant="outlined" onClick={changeCode}>
        Ändern
      </Button>
    </>
  );
}
